import { AccordionItem } from "../components/AccordionItem";



const Faq = () => {

    const general = [
        { title: "Driver Team Taxi ဆိုတာ ဘာလဲ။", content: "Driver Team Taxi သည် ထားဝယ်အခြေစိုက် ယုံကြည်စိတ်ချရသော သယ်ယူပို့ဆောင်ရေးဝန်ဆောင်မှုတစ်ခုဖြစ်ပြီး သုံးဘီးတပ် (Tuk Tuk) ယာဉ်များကို တစ်ကီလိုမီတာလျှင် 1,400 ကျပ်နှုန်းဖြင့် သက်သာသောနှုန်းဖြင့် စီးနင်းခွင့်ပေးထားသည်။" },
        { title: "Driver Team Taxi ကိုဘယ်မှာ ရနိုင်ပါသလဲ။", content: "ကျွန်ုပ်တို့၏ဝန်ဆောင်မှုများကို ထားဝယ်နှင့် သက်ဆိုင်ရာမြို့နယ်များတွင် လောလောဆယ်ရရှိနိုင်ပါသည်။" },
        { title: "Driver Team လည်ပတ်တာ ဘယ်လောက်ကြာပြီလဲ။", content: "Driver Team Taxi ကျွန်တော်တို့ ထားဝယ်အသိုက်အဝန်းကို တသမတ်တည်းနဲ့ အရည်အသွေးကောင်းတဲ့ စီးနင်းမှု၊ ဝန်ဆောင်မှုတွေနဲ့ တစ်နှစ်ကျော်ကြာ ဝန်ဆောင်မှုပေးနေပါပြီ။" },
    ];

    const booking = [
        { title: "သုံးဘီ (Tuk Tuk) စီးဖို့ ဘယ်လိုကြိုတင်မှာယူရမလဲ။", content: "ကျွန်ုပ်တို့၏ မိုဘိုင်းအက်ပ်မှတစ်ဆင့် သို့မဟုတ် ကျွန်ုပ်တို့၏ ဖောက်သည် ပံ့ပိုးကူညီရေးလိုင်းကို ဖုန်းခေါ်ဆိုခြင်းဖြင့် သင်သည် စီးနင်းမှုကို ကြိုတင်မှာယူနိုင်ပါသည်။" },
        { title: "အခြားတစ်ယောက်အတွက် သုံးဘီး (Tuk Tuk) စီးဖို့ ကြိုတင်စာရင်းပေးလို့ရပါသလား။", content: "ဟုတ်ကဲ့၊ ကျွန်ုပ်တို့၏အက်ပ်ကို အသုံးပြု၍ အခြားသူတစ်ဦးဦးအတွက် သုံးဘီး(Tuk Tuk) စီးရန် သို့မဟုတ် ကျွန်ုပ်တို့ကိုခေါ်ဆိုသည့်အခါ လိုအပ်သောအသေးစိတ်အချက်အလက်များကို ပေးခြင်းဖြင့်သင်ကြိုတင်မှာယူနိုင်ပါသည်။" },
        { title: "ကြိုတင်စီစဉ်ထားသော စီးနင်းမှုများကို ကမ်းလှမ်းပါသလား။", content: "ဟုတ်ကဲ့၊ ကျွန်ုပ်တို့၏အက်ပ်မှတစ်ဆင့် သို့မဟုတ် ကျွန်ုပ်တို့၏အကူအညီပေးရေးအဖွဲ့ကို ဆက်သွယ်ခြင်းဖြင့် သင့်စီးနင်းမှုကို ကြိုတင်စီစဉ်နိုင်ပါသည်။" },

    ];

    const price = [
        { title: "ယာဉ်စီးခက ဘယ်လောက်လဲ။", content: "ကျွန်ုပ်တို့၏ နှုန်းထားမှာ မြို့တွင်းနှင့် သက်ဆိုင်ရာမြို့နယ်မျာအတွင်း စီးနင်းမှုအတွက် တစ်ကီလိုမီတာလျှင် 1,400 ကျပ် ဖြစ်ပါသည်။" },
        { title: "အမြင့်ဆုံးနာရီများ သို့မဟုတ် ပုံမှန်ဖောက်သည်များအတွက် ထပ်လောင်းကျသင့်ငွေ ရှိပါသလား။", content: "မရှိပါ၊ ကျွန်ုပ်တို့သည် စီးနင်းမှုအားလုံးအတွက် တူညီသောဈေးနှုန်းကို အမြင့်ဆုံးအချိန်အတွင်း အပိုအခကြေးငွေမယူဘဲ ထိန်းသိမ်းထားပါသည်။" },
        { title: "ကျွန်ုပ်၏စီးနင်းမှုအတွက် မည်သို့ပေးဆောင်နိုင်မည်နည်း။", content: "စီးနင်းမှုအပြီးတွင် ယာဉ်မောင်းထံသို့ တိုက်ရိုက်ငွေသားဖြင့် ငွေပေးချေနိုင်သည်။" }

    ];

    const danger = [
        { title: "ယာဉ်အန္တရာယ်ကင်းသလား။", content: "ကျွန်ုပ်တို့၏ မော်တော်ယာဉ်များအားလုံးသည် ပုံမှန်စစ်ဆေးခံယူပြီး သင့်လုံခြုံရေးအတွက် အပြည့်အဝအာမခံပါသည်။" },
        { title: "ယာဉ်မောင်းအရည်အသွေးကို ဘယ်လိုအာမခံပါသလဲ။", content: "ကျွန်ုပ်တို့၏ ယာဉ်မောင်းများသည် ဘေးကင်းပြီး ယဉ်ကျေးပျူငှာသော ဝန်ဆောင်မှုကို ပေးဆောင်ရန် ပရော်ဖက်ရှင်နယ် လေ့ကျင့်သင်ကြားပြီး နောက်ခံစစ်ဆေးထားပါသည်။" },
    ];

    const tech = [
        { title: "Driver Team အတွက် မိုဘိုင်းအက်ပ်ရှိပါသလား။", content: "ဟုတ်ပါတယ်၊ ကျွန်ုပ်တို့၏အက်ပ်ကို Google Play Store နှင့် Apple App Store တွင်ဒေါင်းလုဒ်လုပ်နိုင်ပါသည်။" },
        { title: "အက်ပ်တွင် မည်သည့်အင်္ဂါရပ်များကို ပေးဆောင်သနည်း။", content: "ဤအက်ပ်သည် သင့်အား စီးနင်းမှုများကို ဘွတ်ကင်လုပ်ရန် များကို အချိန်နှင့်တစ်ပြေးညီ ခြေရာခံရန်၊ ယာဉ်မောင်းအသေးစိတ်အချက်အလက်များကို ကြည့်ရှုရန်နှင့် ဈေးနှုန်းကို ပွင့်လင်းမြင်သာစွာ စစ်ဆေးနိုင်စေမည်ဖြစ်သည်။" },
        { title: "ကျွန်ုပ်၏စီးနင်းမှုကို ခြေရာခံနိုင်ပါသလား။", content: "ဟုတ်ကဲ့၊ ကျွန်ုပ်တို့၏မိုဘိုင်းအက်ပ်ကို အသုံးပြု၍ သင့်စီနင်းမှုကို အချိန်နှင့်တစ်ပြေးညီ ခြေရာခံနိုင်ပါသည်။" }
    ];

    const customer = [
        { title: "ဖောက်သည်အကူအညီကို ဘယ်လိုဆက်သွယ်ရမလဲ။", content: "သင်သည် (+95) 9882577171 သို့ ဖုန်းမှတစ်ဆင့် ကျွန်ုပ်တို့ထံ ဆက်သွယ်နိုင်သည် သို့မဟုတ် driverteam7@gmail.com တွင်ကျွန်ုပ်တို့ထံ အီးမေးလ်ပေးပို့နိုင်ပါသည်။" },
        { title: "သုံးဘီး (Tuk Tuk) ထဲမှာတစ်ခုခုပျောက်သွားရင် ဘယ်လိုလုပ်မလဲ။", content: "ဆုံးရှုံးသွားသော ပစ္စည်းနှင့် စီးနင်းမှုအသေးစိတ်အချက်အလက်များဖြင့် ကျွန်ုပ်တို့၏ ဖောက်သည်အကူအညီကို ချက်ချင်းဆက်သွယ်ပါ။ ၎င်းကို ပြန်လည်ရယူရန် ကျွန်ုပ်တို့ အကောင်းဆုံးလုပ်ဆောင်ပါမည်။" }
    ];

    return (
        <>
            <div className=" px-[30px]">
                <div style={{ marginTop: "200px" }}>
                    <h1 className=" text-2xl font-bold mt-10">FAQS</h1>
                    <h3 className=" text-lg mt-2 text-black-50">Mingalar Par, How can we help you?</h3>
                </div>

            </div>

            <div className=" mt-8 divider"></div>

            <div className=" px-[30px]">
                <h1 className="text-2xl font-bold mt-10"> အထွေအထွေမေးခွန်းများ </h1>

                <div className="w-full my-6 bg-white shadow-lg">
                    {general.map((item, index) => (
                        <AccordionItem
                            key={index}
                            title={item.title}
                            content={item.content}
                        />
                    ))}
                </div>

                <h1 className="text-2xl font-bold mt-10"> ဘွတ်ကင်မေးခွန်းများ </h1>

                <div className="w-full my-6 bg-white shadow-lg">
                    {booking.map((item, index) => (
                        <AccordionItem
                            key={index}
                            title={item.title}
                            content={item.content}
                        />
                    ))}
                </div>

                <h1 className="text-2xl font-bold mt-10"> ဈေးနှုန်းနှင့် ငွေပေးချေမှု </h1>

                <div className="w-full my-6 bg-white shadow-lg">
                    {price.map((item, index) => (
                        <AccordionItem
                            key={index}
                            title={item.title}
                            content={item.content}
                        />
                    ))}
                </div>


                <h1 className="text-2xl font-bold mt-10"> ယာဉ်အန္တရာယ်ကင်းရှင်းရေး။ </h1>
                <div className="w-full my-6 bg-white shadow-lg">
                    {danger.map((item, index) => (
                        <AccordionItem
                            key={index}
                            title={item.title}
                            content={item.content}
                        />
                    ))}
                </div>

                <h1 className="text-2xl font-bold mt-10"> အက်ပ်နှင့် နည်းပညာ </h1>
                <div className="w-full my-6 bg-white shadow-lg">
                    {tech.map((item, index) => (
                        <AccordionItem
                            key={index}
                            title={item.title}
                            content={item.content}
                        />
                    ))}
                </div>

                <h1 className="text-2xl font-bold mt-10"> ဖောက်သည်ပံ့ပိုးမှု </h1>
                <div className="w-full my-6 bg-white shadow-lg">
                    {customer.map((item, index) => (
                        <AccordionItem
                            key={index}
                            title={item.title}
                            content={item.content}
                        />
                    ))}
                </div>

            </div>
        </>
    )
}

export default Faq;